import { Link } from "react-router-dom";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { usePageMeta } from "@/hooks/usePageMeta";

const scopes = [
  {
    icon: "ri-film-line",
    title: "电影内容",
    desc: "覆盖院线新片、经典佳作与类型片单，提供上映时间、评分与主创信息。",
  },
  {
    icon: "ri-tv-2-line",
    title: "电视剧集",
    desc: "聚合热播与完结剧集资源，标注集数、季数与更新状态，追剧更清晰。",
  },
  {
    icon: "ri-newspaper-line",
    title: "影视资讯",
    desc: "跟踪行业动态、平台信息与技术趋势，第一时间送达热点内容。",
  },
  {
    icon: "ri-book-open-line",
    title: "深度专题",
    desc: "以评论与解说的形式，解读影史脉络、幕后制作与创作理念。",
  },
];

const team = [
  { name: "陆之恒", role: "主编 / 内容策划", avatar: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20confident%20asian%20man%20in%20a%20deep%20blue%20shirt%20on%20a%20simple%20light%20gray%20studio%20background%2C%20warm%20soft%20lighting%2C%20clean%20editorial%20headshot%2C%20highly%20detailed%20photography&width=400&height=400&seq=team-01-avatar&orientation=squarish" },
  { name: "苏映雪", role: "资深影评人", avatar: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20an%20elegant%20asian%20woman%20in%20a%20navy%20blazer%20on%20a%20simple%20light%20gray%20studio%20background%2C%20warm%20soft%20lighting%2C%20clean%20editorial%20headshot%2C%20highly%20detailed%20photography&width=400&height=400&seq=team-02-avatar&orientation=squarish" },
  { name: "程野", role: "资讯编辑", avatar: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20friendly%20young%20asian%20man%20with%20glasses%20in%20a%20blue%20knit%20sweater%20on%20a%20simple%20light%20gray%20studio%20background%2C%20warm%20soft%20lighting%2C%20clean%20editorial%20headshot%2C%20highly%20detailed%20photography&width=400&height=400&seq=team-03-avatar&orientation=squarish" },
  { name: "林泠", role: "专题策划", avatar: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20creative%20asian%20woman%20in%20a%20warm%20orange%20top%20on%20a%20simple%20light%20gray%20studio%20background%2C%20warm%20soft%20lighting%2C%20clean%20editorial%20headshot%2C%20highly%20detailed%20photography&width=400&height=400&seq=team-04-avatar&orientation=squarish" },
];

export default function AboutPage() {
  usePageMeta(
    "关于我们 - 影视工厂",
    "了解影视工厂的品牌背景、服务宗旨与内容范围，我们致力于为影视爱好者提供权威、丰富、可视化的影视内容与行业动态。",
    "关于影视工厂,影视工厂介绍,影视内容平台,影视资讯网站"
  );

  return (
    <div className="bg-background-50">
      <div className="bg-background-100 border-b border-background-200">
        <div className="mx-auto max-w-page px-4 md:px-6 py-8 md:py-14">
          <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />
          <h1 className="mt-5 font-heading text-3xl md:text-5xl text-foreground-950 tracking-wide">
            关于影视工厂
          </h1>
          <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-3xl leading-8">
            影视工厂是一个综合性影视内容平台，聚焦电影与电视剧的资讯、推荐、资源介绍与影视热点解析，
            让每一位影视爱好者、追剧观众和内容创作者，都能快速获取权威、丰富、可视化的影视内容。
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-page px-4 md:px-6 py-12 md:py-16">
        <section className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-center">
          <div className="rounded-lg overflow-hidden aspect-[16/11] bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=modern%20creative%20film%20production%20studio%20interior%20with%20deep%20blue%20lighting%20and%20warm%20orange%20accents%2C%20cameras%20and%20screens%2C%20clean%20editorial%20photography%2C%20highly%20detailed%20interior&width=1200&height=820&seq=about-brand&orientation=landscape"
              alt="影视工厂工作场景"
              title="影视工厂 内容制作"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div>
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-50 text-primary-700 text-xs">
              <i className="ri-building-2-line" />
              品牌背景
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-3xl text-foreground-950 tracking-wide">
              让好内容被更多人看见
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-700 leading-8">
              影视工厂诞生于一群热爱影视的创作者之手。我们发现，观众获取影视信息的渠道越来越多，
              但真正权威、清晰、有深度的内容却依然稀缺。于是我们决定做一个更懂观众的内容平台。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-8">
              我们坚持「内容为王、可视优先」的理念，用结构化的信息、清晰的筛选与精美的呈现，
              帮助用户在海量影视内容中快速找到真正想看的东西。
            </p>
          </div>
        </section>

        <section className="mt-16 md:mt-24">
          <div className="flex items-center gap-3">
            <span className="w-1.5 h-6 rounded-full bg-accent-500" />
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 tracking-wide">
              服务宗旨与内容范围
            </h2>
          </div>
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {scopes.map((scope) => (
              <div key={scope.title} className="rounded-lg bg-background-100 border border-background-200 p-6">
                <span className="w-12 h-12 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                  <i className={`${scope.icon} text-2xl`} />
                </span>
                <h3 className="mt-4 font-heading text-xl text-foreground-950 tracking-wide">
                  {scope.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-7">{scope.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-16 md:mt-24">
          <div className="flex items-center gap-3">
            <span className="w-1.5 h-6 rounded-full bg-accent-500" />
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 tracking-wide">
              团队介绍
            </h2>
          </div>
          <div className="mt-8 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {team.map((member) => (
              <div key={member.name} className="rounded-lg bg-background-50 border border-background-200 p-5 text-center">
                <div className="w-20 h-20 md:w-24 md:h-24 mx-auto rounded-full overflow-hidden bg-background-200">
                  <img
                    src={member.avatar}
                    alt={member.name}
                    title={`影视工厂 ${member.role}`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <h3 className="mt-4 font-medium text-foreground-950">{member.name}</h3>
                <p className="mt-1 text-xs text-foreground-500">{member.role}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-16 md:mt-24 grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="rounded-lg bg-background-100 border border-background-200 p-6 md:p-8">
            <h2 className="font-heading text-xl text-foreground-950 tracking-wide flex items-center gap-2">
              <i className="ri-copyright-line text-primary-500" />
              版权声明
            </h2>
            <p className="mt-4 text-sm text-foreground-700 leading-8">
              本站所展示的影视名称、海报、简介等内容均为演示用虚构内容，仅用于产品功能展示，
              不代表任何真实影视作品。站内图文版权归影视工厂所有，未经许可请勿用于商业用途。
            </p>
          </div>
          <div className="rounded-lg bg-background-100 border border-background-200 p-6 md:p-8">
            <h2 className="font-heading text-xl text-foreground-950 tracking-wide flex items-center gap-2">
              <i className="ri-shield-check-line text-primary-500" />
              免责声明
            </h2>
            <p className="mt-4 text-sm text-foreground-700 leading-8">
              影视工厂不提供任何视频播放、下载或在线观看服务，站内内容仅供信息参考。
              若因参考本站内容产生的任何影响，本站不承担相应责任。如需合作，请通过联系页面与我们取得联系。
            </p>
          </div>
        </section>

        <section className="mt-16 md:mt-24 rounded-lg bg-gradient-to-br from-primary-600 to-primary-900 p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-background-50 tracking-wide">
              有想法，想和我们聊聊？
            </h2>
            <p className="mt-3 text-sm md:text-base text-background-200">
              无论是内容合作、反馈建议还是问题咨询，我们都欢迎你的来信。
            </p>
          </div>
          <Link
            to="/contact"
            className="shrink-0 px-7 py-3.5 rounded-md bg-accent-500 text-foreground-950 text-sm hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
          >
            联系我们
          </Link>
        </section>
      </div>
    </div>
  );
}